module.exports = __webpack_public_path__ + "img/steps.de2c98ea.svg";